(() => {
  if (window.abHeaderRefreshLoaded) return;
  window.abHeaderRefreshLoaded = true;
  const bind = () => {
    document.querySelectorAll('.mb-min-nav').forEach(drawer => {
      if (drawer.dataset.keyboardReady) return;
      drawer.dataset.keyboardReady = 'true';
      const panel = drawer.querySelector('.mb-min-nav-container');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'All categories');
      panel.tabIndex = -1;
      let trigger;
      drawer.querySelector('.mb-nav-close')?.setAttribute('aria-label', 'Close menu');
      const section = drawer.closest('.shopify-section');
      const buttons = section?.querySelectorAll('.btn-sidetoggle') || [];
      buttons.forEach(button => {
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', () => { trigger = button; });
      });
      new MutationObserver(() => {
        const open = drawer.classList.contains('is-open');
        buttons.forEach(button => button.setAttribute('aria-expanded', String(open)));
        if (open) {
          if (typeof trapFocus === 'function') trapFocus(panel, drawer.querySelector('.mb-nav-close'));
          else drawer.querySelector('.mb-nav-close')?.focus();
        } else if (typeof removeTrapFocus === 'function') removeTrapFocus(trigger);
        else trigger?.focus();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      drawer.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); drawer.classList.remove('is-open'); }
      });
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
